import { Button, message } from "antd";
import {
  FormDialog,
  FormLayout,
  FormItem,
  Input,
  Select,
  Switch,
} from "@formily/antd";
import { createSchemaField } from "@formily/react";
import AdministrativeTreeSelect from "@/components/common/AdministrativeTreeSelect";
import DepartmentTypeSelect from "@/components/common/DepartmentTypeSelect/DepartmentTypeSelectForForm";
import { department as departmentService } from "@/services";
const schema = {
  type: "object",
  properties: {
    types: {
      type: "string",
      title: "类型",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "DepartmentTypeSelect",
      "x-component-props": "{{{token, roles}}}",
    },
    name: {
      type: "string",
      title: "单位名称",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "Input",
    },
    short_name: {
      type: "string",
      title: "单位简称",
      "x-decorator": "FormItem",
      "x-component": "Input",
    },
    office_phone: {
      type: "string",
      title: "办公电话",
      "x-decorator": "FormItem",
      "x-component": "Input",
    },
    director_name: {
      type: "string",
      title: "负责人姓名",
      "x-decorator": "FormItem",
      "x-component": "Input",
    },
    director_job: {
      type: "string",
      title: "负责人职务",
      "x-decorator": "FormItem",
      "x-component": "Input",
    },
    director_phone: {
      type: "string",
      title: "负责人电话",
      format: "phone",
      "x-decorator": "FormItem",
      "x-component": "Input",
    },
    administrative: {
      type: "string",
      title: "行政区划",
      required: true,
      "x-decorator": "FormItem",
      "x-component": "AdministrativeTreeSelect",
      "x-component-props": "{{{token}}}",
    },
  },
};

const SchemaField = createSchemaField({
  components: {
    FormItem,
    Input,
    Select,
    AdministrativeTreeSelect,
    DepartmentTypeSelect,
    Switch,
  },
});

function DepartmentAddButton({ token, roles, callback }) {
  return (
    <FormDialog.Portal>
      <Button
        type="primary"
        onClick={() => {
          FormDialog({ title: "新增单位" }, "modal-dialog", () => {
            return (
              <FormLayout labelCol={6} wrapperCol={16}>
                <SchemaField
                  schema={schema}
                  scope={{
                    token,
                    roles: roles,
                  }}
                />
              </FormLayout>
            );
          })
            .forConfirm((payload, next) => {
              const { types, ...rest } = payload.values;

              departmentService
                .create({ ...rest, types: [types] }, token)
                .then((res) => {
                  message.success("新增成功");
                  callback(Date.now());
                })
                .catch((err) => {
                  message.error(err.message || err);
                })
                .finally(() => {
                  next(payload);
                });
            })
            .open();
        }}
      >
        新增
      </Button>
    </FormDialog.Portal>
  );
}

export default DepartmentAddButton;
